<!-- CONTENT -->
<div class="mt-5 container auth-container animate__animated animate__fadeIn">
    <div class="row justify-content-center">
        <div class="col mt-4 ">

            <!-- CANCEL -->
            <button type="button" 
                    class="btn-close" 
                    aria-label="Close"
                    routerLink="/auth">
            </button>
            
            <!-- TRANSALTE -->
            <div class="ms-3 float-end">
            </div>

            <!-- LOGO-BOX HEADER -->
            <div class="text-center mb-4">
                <div class="logo-auth"></div>
            </div>
            
            <!-- SIGN-UP CONTAINER -->
            <router-outlet></router-outlet>
            
        </div>
    </div>
</div>